import React from 'react'
import { genFileText } from '../renderFiles'
import { getFileIcon } from 'tyan/public'

const File = props => {
	const { file: { FileName, FileExt, FileSize }, file } = props
	const text = genFileText(FileName, FileExt, FileSize)

	const handleClick = () => {
		Tyan.viewFile(file, false)
	}

	const iconCss = `t-fa fa-file-${getFileIcon(FileExt)}`

	return <div className='file' onClick={handleClick}><span className={`icon ${iconCss}`} />{text}</div>
}

export default File